// extracted by mini-css-extract-plugin
module.exports = {"image":"PostBlock_image__8u5Mi","contentContainer":"PostBlock_contentContainer__2rNQx","textWrapper":"PostBlock_textWrapper__APT37"};